import { computed, ref } from 'vue';
import { useContactFormStore } from '../store/contactFormStore';

const QUERY_PARAM_Q = 'q';
const PRIVACY_QUERY_VALUE = 'privacy';

const isPrivacyOptionPriority = (): boolean => {
  return new URLSearchParams(window.location.search)
    .get(QUERY_PARAM_Q)
    ?.toLowerCase() === PRIVACY_QUERY_VALUE;
}

export const useFormTopics = () => {
  const contactFormStore = useContactFormStore();
  const currentTopic = ref<string>('');
  if (isPrivacyOptionPriority()) {
    currentTopic.value = contactFormStore.getFirstFormItem?.topicPrivacyOption ?? '';
  }

  const allTopics = computed(() => {
    const privacy = contactFormStore.getFirstFormItem?.topicPrivacyOption ?? '';
    const contactList = contactFormStore.getFirstFormItem?.topicContactListOption ?? '';
    const otherTopics = contactFormStore.getFirstFormItem?.otherFormTopics ?? [];
    return [privacy, contactList, ...otherTopics].filter(Boolean);
  });

  const privacyActive = computed(() => currentTopic.value === contactFormStore.getFirstFormItem?.topicPrivacyOption);
  const contactListActive = computed(() => currentTopic.value === contactFormStore.getFirstFormItem?.topicContactListOption);
  const otherTopicActive = computed(() => {
    const otherTopics = contactFormStore.getFirstFormItem?.otherFormTopics ?? [];
    return otherTopics.includes(currentTopic.value);
});

  return { currentTopic, allTopics, privacyActive, contactListActive, otherTopicActive };
};
